// extracted by mini-css-extract-plugin
module.exports = {"tabHeader":"style_tabHeader__PDk0C","active":"style_active__3Pgh6"};